import { useStore } from 'vuex'
import { computed, ref } from 'vue'

import FormInputTextField from "../FormInputTextField/FormInputTextField";
import FormInputDropdown from "../FormInputDropdown/FormInputDropdown";

import nameValidator from "foundation/js/inputValidators/nameValidator";
import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";

export default {
    name: "CreateNewFileOverlay",
    components: {
        FormInputTextField,
        FormInputDropdown
    },
    setup(){
        const store = useStore()
        const fileName = ref('')
        const fileTypeDropdown = ref('')

        const fileTypeDropdownOptions = computed(()=> store.state.frivillige.file_type_dropdown_options)
        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)

        let displayError = ref(false)

        const isFormValid = () => {
            return nameValidator(fileName.value) 
                && nonEmptyStringValidator(fileName.value) 
                && nonEmptyStringValidator(fileTypeDropdown.value)
        };

        const submitCreateNewFile = () => {
            const isValid = isFormValid();
            displayError.value = !isValid;

            const body = {
                fileName: fileName.value,
                dokumentType: fileTypeDropdown.value,
                gruppeKode: store.state.frivillige.globalGruppeKode,
                mappeKode: store.getters["frivillige/get_global_folder_id"]
            }

            if (isValid) {
                store.dispatch("frivillige/submitCreateNewFile", {
                    body
                })
                .then(() => {
                    store.dispatch('main/closePageOverlay')
                    store.dispatch('search/refreshSearches')
                });
            }
        };

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "CreateNewFileOverlay",
                labelKey: labelKey,
            });
        
        return {
            fileName,
            fileTypeDropdown,
            isSubmitting,
            displayError,
            fileTypeDropdownOptions,
            submitCreateNewFile,
            nonEmptyStringValidator,
            nameValidator,
            getLabel
        }
        
    }
}